import { get } from 'lodash';
import React, { FC } from 'react';
import SummaryLine from 'src/components/ui-component/form-component/abschluss-page/SummaryLine';
import { useApplication } from 'src/context/ApplicationContext';
import { KOSTEN_ARTEN, NACHWEIS_POSITION_STATUS } from 'src/lib/constants/constant';
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import { sumNachweispositionen } from '../../../../formulas/mittelabruf/kreativ/executeKreativMAFormulas';
import { DisplayDateTime, DisplayEuroMUI } from 'src/utils/formats';
import AbschlussSeiteBox from '../../../../antrag-components/AbschlussSeiteBox';
const MA_P = MittelabrufSchema.attributes;

const AbschlussMaKreativ: FC<{}> = () => {
	const { application } = useApplication();
	const nachweisPositionen = get(application, MA_P.Mittelabruf_Nachweispositions.path, []);

	const personalAngefallen = sumNachweispositionen(
		nachweisPositionen,
		KOSTEN_ARTEN.Personalkosten,
		NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben,
	);
	const sachAngefallen = sumNachweispositionen(nachweisPositionen, KOSTEN_ARTEN.Sachkosten, NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben);
	const personalGeplant = sumNachweispositionen(nachweisPositionen, KOSTEN_ARTEN.Personalkosten, NACHWEIS_POSITION_STATUS.geplant);
	const sachGeplant = sumNachweispositionen(nachweisPositionen, KOSTEN_ARTEN.Sachkosten, NACHWEIS_POSITION_STATUS.geplant);

	const projektAusgabenAngefallen = personalAngefallen + sachAngefallen;
	const projektAusgabenGeplant = personalGeplant + sachGeplant;

	return (
		<AbschlussSeiteBox>
			<SummaryLine
				label='Datum der Einreichung'
				value={
					get(application, MA_P.Allgemein_Eingereicht_Am.path) ?
						DisplayDateTime(get(application, MA_P.Allgemein_Eingereicht_Am.path))
					:	'noch nicht eingereicht'
				}
			/>
			<SummaryLine label='Projekttitel' value={get(application, MA_P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, '')} />
			<SummaryLine label='Projektausgaben' value={''} />
			<SummaryLine
				label='bis jetzt angefallene Projektausgaben'
				value={DisplayEuroMUI(projektAusgabenAngefallen)}
				labelPadding={'0.75rem 0 0.75rem 2rem'}
				boldLabel={true}
			/>
			<SummaryLine
				label='darunter Personalausgaben'
				value={DisplayEuroMUI(personalAngefallen)}
				labelPadding={'0.75rem 0 0.75rem 3rem'}
				valueFontWeight={400}
			/>
			<SummaryLine
				label='darunter Sachausgaben'
				value={DisplayEuroMUI(sachAngefallen)}
				labelPadding={'0.75rem 0 0.75rem 3rem'}
				valueFontWeight={400}
			/>
			<SummaryLine
				label='in den nächsten drei Monaten anfallende Projektausgaben'
				value={DisplayEuroMUI(projektAusgabenGeplant)}
				labelPadding={'0.75rem 0 0.75rem 2rem'}
				boldLabel={true}
			/>
			<SummaryLine
				label='darunter Personalausgaben'
				value={DisplayEuroMUI(personalGeplant)}
				labelPadding={'0.75rem 0 0.75rem 3rem'}
				valueFontWeight={400}
			/>
			<SummaryLine
				label='darunter Sachausgaben'
				value={DisplayEuroMUI(sachGeplant)}
				labelPadding={'0.75rem 0 0.75rem 3rem'}
				valueFontWeight={400}
			/>
			<SummaryLine
				label={
					<>
						berechnete max. Förderung / Mittelabruf
						<br />
						<span style={{ fontWeight: 400 }}>
							(vorbehaltlich einer fachlichen Prüfung durch die Hessen Agentur)
						</span>
					</>
				}
				value={DisplayEuroMUI(get(application, MA_P.Ermittlung_Des_Auszahlungsbetrages_Anforderungsbetrag.path, 0))}
				boldLabel={true}
			/>
		</AbschlussSeiteBox>
	);
};

export default AbschlussMaKreativ;
